import { render, staticRenderFns } from "./Platforms.vue?vue&type=template&id=2354ce0b&scoped=true"
import script from "./Platforms.vue?vue&type=script&lang=js"
export * from "./Platforms.vue?vue&type=script&lang=js"
import style0 from "./Platforms.vue?vue&type=style&index=0&id=2354ce0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2354ce0b",
  null
  
)

export default component.exports